<!-- 编辑权限 -->
<template>
	<div class="manageAuth" v-if="isShow">
		<h3 class="title">{{title}}</h3>
		<el-form class="form" label-position="left" label-width="80px" :model="formData" :disabled = "!canEdit">
			<el-form-item v-if="formData.parentMenuName" label="上级菜单 : ">
				<el-input v-model="formData.parentMenuName" disabled=""></el-input>
			</el-form-item>
			<el-form-item label="父级ID : ">
				<el-input v-model="formData.parentMenuId" disabled="disabled"></el-input>
			</el-form-item>
			<el-form-item required label="菜单名称 : ">
				<el-input v-model="formData.menuName"></el-input>
			</el-form-item>
			<el-form-item label="菜单图标 : ">
				<el-popover placement="bottom-start" trigger="click">
					<icon-select @selected="selectedAdd" />
					<el-input style="margin-top:5px;" :prefix-icon="formData.menuIco" slot="reference" v-model="formData.menuIco" placeholder="点击选择图标" readonly>
						<i v-if="formData.menuIco" slot="prefix" :icon-class="formData.menuIco" />
						<span v-else slot="prefix" />
						<el-button slot="append" icon="el-icon-arrow-down"></el-button>
					</el-input>
				</el-popover>
			</el-form-item>
			<el-form-item required label="菜单地址 : " v-if="formData.menuType != 'auth'" :disabled="formData.viewUrl && formData.viewUrl.length>0">
				<el-input v-model="formData.menuUrl" ></el-input>
			</el-form-item>
			<el-form-item label="内嵌url : ">
				<el-input v-model="formData.viewUrl"></el-input>
			</el-form-item>
			<el-form-item label="菜单说明 : ">
				<el-input v-model="formData.description"></el-input>
			</el-form-item>
			<el-form-item label="权限配置 : ">
				<el-input v-model="formData.mustVerifys"></el-input>
			</el-form-item>
			<el-form-item label="权限顺序 : ">
				<el-input onkeyup="value=value.replace(/[^\d]/g,'')" maxlength="10" v-model="formData.orderNumber"></el-input>
			</el-form-item>
			<el-form-item label="菜单类型 : ">
				<el-select v-model="formData.menuType" placeholder="请选择">
					<el-option label="菜单" value="menu" v-if="!showAuthButton || showAuthButton.includes('menu')"></el-option>
					<el-option label="授权" value="auth" v-if="!showAuthButton || showAuthButton.includes('auth')"></el-option>
					<el-option label="按钮" value="button" v-if="!showAuthButton || showAuthButton.includes('button')"></el-option>
				</el-select>
			</el-form-item>
			<!-- <el-form-item label="菜单状态 : ">
				<el-select v-model="formData.state" placeholder="请选择">
					<el-option label="正常" value="0"></el-option>
					<el-option label="锁定" value="1"></el-option>
				</el-select>
			</el-form-item> -->
		</el-form>
		<div class="footer" v-if = "canEdit">
			<el-button @click="close">取消</el-button>
			<el-button type="primary" @click="commit()">提交</el-button>
		</div>
	</div>
</template>
<script>
import IconSelect from './IconSelect/index';
export default {
	name: "manageAuth",
	components: {
		IconSelect
	},
	props: {
		showAuthButton: Array
	},
	data() {
		return {
			isShow: false,
			operType: "create",
			title: "权限",
			canEdit: true,
			originData: null,
			formData: {
				"menuId": "",
				"parentMenuId": "",
				"parentMenuName": "",
				"menuName": "",
				"description": '',
				"menuUrl": "",
				"createTime": '',
				"createBy": '',
				"menuIco": '',
				"state": '0',
				"orderNumber": '',
				"menuType": 'menu',
				"mustVerifys": '',
				"viewUrl": ''
			},
		}
	},
	computed: {

	},
	watch: {
		"formData.viewUrl": {
			handler(newValue, oldValue) {
				this.formData.menuUrl = newValue && newValue.length > 0 ? "/iframe" : "";
			},
		},
	},
	mounted() {

	},
	methods: {
		openManageAuth(operType, data) {
			this.operType = operType;
			this.originData = Object.assign({}, data);
			this.setState();
			this.isShow = true;
		},
		verify() {
			if(this.formData.menuName.length > 20) {
				this.$message({
					message: "授权名称不可大于20个字符",
					type: "error"
				})
				return false;
			}
			// 如果不为权限则须要验证菜单url
			if(this.formData.menuType !== "auth" && this.formData.menuUrl.length < 1) {
				this.$message({
					message: "请输入菜单地址",
					type: "error"
				})
				return false;
			}
			return true;
		},
		commit() {
			if(!this.verify()) return false;
			this.$emit("commit",this.operType,this.formData);
		},
		close() {
			this.isShow = false;
			this.$emit("close");
		},
		// 选图标
		selectedAdd(name) {
			this.formData.menuIco = name
		},
		setState() {
			this.resetFormData();
			switch (this.operType) {
				case "create":
					this.title = "新增权限";
					this.canEdit = true;
					this.formData.parentMenuId = this.originData.menuId;
					this.formData.parentMenuName = this.originData.menuName;
					break;
				case "update":
					this.title = "更新权限";
					this.canEdit = true;
					this.formData = this.originData;
					console.log(this.formData);
					break;
				case "view":
					this.title = this.originData.menuName;
					this.canEdit = false;
					this.formData = this.originData;
					break;
				default:
					return;
			}
		},
		resetFormData() {
			this.formData = {
				"menuId": "",
				"parentMenuId": "",
				"parentMenuName": "",
				"menuName": "",
				"description": '',
				"menuUrl": "",
				"createTime": '',
				"createBy": '',
				"menuIco": '',
				"state": '0',
				"orderNumber": '',
				"menuType": 'menu',
				"mustVerifys": '',
				"viewUrl": ''
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.manageAuth {
	width: 500px;
	border: 1px solid #e6e9ef;
	border-radius: 4px;
	overflow: hidden;
}

.title {
	height: 44px;
	line-height: 44px;
	background: #F6F7F9;
	border-bottom: 1px solid #E8E8E8;
	padding-left: 30px;
	color: #3C4353;
}

.form {
	margin: 20px;
}

.footer {
	margin: 20px;
	text-align: right;
}
</style>